import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Setup from "@/pages/Setup";
import AcceptInvite from "@/pages/AcceptInvite";
import Review from "@/pages/Review";
import PublicMediaKit from "@/pages/PublicMediaKit";
import PublicRoster from "@/pages/PublicRoster";
import Dashboard from "@/pages/Dashboard";
import Roster from "@/pages/Roster";
import AthleteProfile from "@/pages/AthleteProfile";
import StockWatch from "@/pages/StockWatch";
import Alerts from "@/pages/Alerts";
import Users from "@/pages/Users";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/review/:token" element={<Review />} />
            <Route path="/kit/:token" element={<PublicMediaKit />} />
            <Route path="/roster-public" element={<PublicRoster />} />
            <Route path="/share/roster" element={<PublicRoster />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/roster" element={<Roster />} />
                <Route path="/athlete/:id" element={<AthleteProfile />} />
                <Route path="/stock-watch" element={<StockWatch />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/team" element={<Users />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
